import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=5566b568&scoped=true"
import script from "./courseList.vue?vue&type=script&lang=js"
export * from "./courseList.vue?vue&type=script&lang=js"
import style0 from "../asset/css/list.scss?vue&type=style&index=0&id=5566b568&prod&lang=scss&scoped=true&external"
import style1 from "./courseList.vue?vue&type=style&index=1&id=5566b568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5566b568",
  null
  
)

export default component.exports